import { SHOOB_DAY_SUFFIX, isShoobDayKey, stripShoobDaySuffix, appointmentSchoolId, STUDIO_SCHOOL_ID } from './shoob-day'

describe('isShoobDayKey', () => {
  it('is true for a day key tagged with the Shoob suffix', () => {
    expect(isShoobDayKey(`2026-10-03${SHOOB_DAY_SUFFIX}`)).toBe(true)
  })

  it('is false for a plain school day key', () => {
    expect(isShoobDayKey('2026-10-03')).toBe(false)
  })

  it('is false for null/undefined (no day selected yet)', () => {
    expect(isShoobDayKey(null)).toBe(false)
    expect(isShoobDayKey(undefined)).toBe(false)
  })
})

describe('stripShoobDaySuffix', () => {
  it('removes the Shoob suffix, leaving the plain date', () => {
    expect(stripShoobDaySuffix(`2026-10-03${SHOOB_DAY_SUFFIX}`)).toBe('2026-10-03')
  })

  it('is a no-op on a plain school day key', () => {
    expect(stripShoobDaySuffix('2026-10-03')).toBe('2026-10-03')
  })
})

describe('appointmentSchoolId', () => {
  const HOME_SCHOOL = 2548 // Bear Creek High

  // ⚠️ The bug this pins (2026-08-28). The picker offers the student's school
  // days AND the studio's, so the school has to move with the DAY. The
  // reschedule path did not set it, kept Bear Creek on a studio-only day, and
  // the server refused the move with "No shooting schedule found for ...".
  it('books a Shoob day against the studio, not the home school', () => {
    expect(appointmentSchoolId({ isAtShoob: true, schoolId: HOME_SCHOOL })).toBe(STUDIO_SCHOOL_ID)
  })

  it('books a school day against the student school, not the studio', () => {
    expect(appointmentSchoolId({ isAtShoob: false, schoolId: HOME_SCHOOL })).toBe(HOME_SCHOOL)
  })

  // Moving a studio booking BACK to a school day has to re-home it too.
  it('is driven by the picked day, not by where the booking already lives', () => {
    const dayKey = '2026-09-28'
    expect(appointmentSchoolId({ isAtShoob: isShoobDayKey(dayKey), schoolId: HOME_SCHOOL })).toBe(HOME_SCHOOL)
  })
})
